@if (showMap) {
  <div class="map-container">
    <iframe title="Map" [src]="mapsUrl" loading="lazy" allowfullscreen referrerpolicy="no-referrer-when-downgrade"> </iframe>
  </div>
}
